import { useQuery } from "@tanstack/react-query"
import { handleResponse } from "../handleResponse.ts"
import { BlockchainNetwork } from "../../backend/constants.ts"

type SmartContractAddress = string

const getMarketPrices = async (blockchain: BlockchainNetwork, currencies: string[]) => fetch(`/api/price`, {
    method: 'POST',
    headers: {
        "Content-Type": "application/json",
    },
    body: JSON.stringify({ blockchain, currencies })
})

export const useGetMarketPriceQuery = (blockchain: BlockchainNetwork | undefined, currency?: string) => useQuery({
    queryKey: ['price' + blockchain + currency],
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24,
    enabled: !!blockchain && !!currency,
    retry: 1,
    queryFn: async () => (currency ?
        handleResponse<Record<SmartContractAddress, number>>(await getMarketPrices(blockchain!, [currency])) :
        null),
})


export const useGetMarketPricesQuery = (
    blockchain: BlockchainNetwork | undefined, entityId:string | undefined, step:number, currencies: string[]
) => useQuery({
    queryKey: ['price' + blockchain + entityId + step],
    staleTime: 1000 * 60 * 5,
    enabled: !!blockchain && !!entityId && currencies.length > 0,
    retry: 1,
    queryFn: async () =>
        handleResponse<Record<SmartContractAddress, number>>(await getMarketPrices(blockchain!, currencies)),
})
